import client from '../clients/client';
import { AuditEventDetail, AuditEventPage, AuditFilters } from '../models/audit';

export const getAuditEvents = async (filters: AuditFilters): Promise<AuditEventPage> => {
  const params = Object.fromEntries(Object.entries(filters).filter(([, value]) => value !== undefined && value !== ''));
  const response = await client.get<AuditEventPage>('/audit/events', { params });
  return response.data;
};

export const getAuditEvent = async (id: number): Promise<AuditEventDetail> => {
  const response = await client.get<AuditEventDetail>(`/audit/events/${id}`);
  return response.data;
};

export const revertAuditEvent = async (id: number): Promise<{ event: AuditEventDetail; revert: AuditEventDetail }> => {
  const response = await client.post(`/audit/events/${id}/revert`);
  return response.data;
};
